export const STATUS = {
  empty: { label: "À projeter", action: "Dessiner" },
  drawing: { label: "Tracé en cours", action: "Continuer" },
  drawn: { label: "Projeté", action: "Redessiner" },
};
export const MOVABLE_RATIO = 0.08;

export const UNIT_ROWS = [
  { key: "pin", label: "Pin", suffix: "€/ha" },
  { key: "chene", label: "Chêne", suffix: "€/ha" },
  { key: "conifere", label: "Conifères", suffix: "€/ha" },
  { key: "feuillus", label: "Feuillus", suffix: "€/ha" },
  { key: "mixte", label: "Forêt Mixte", suffix: "€/ha" },
  { key: "shrubland", label: "Strate arbustive", suffix: "€/ha" },
  { key: "grassland", label: "Strate herbacée", suffix: "€/ha" },
  { key: "co2", label: "CO₂", suffix: "€/tCO₂" },
  { key: "building", label: "Valeur immobilière du sauvé ", suffix: "€/m2." },
  // derived: always 0.08 × immobilier, disabled, never sent to the backend
  {
    key: "buildingMovable",
    label: "Valeur mobilière du sauvé",
    suffix: "€/m2.",
    derived: true,
  },
];

export const STEPS = [
  "Calcul des surfaces…",
  "Calcul du CO₂…",
  "Analyse des bâtiments…",
];

export const UNITS = {
  area: { unit: "ha", decimals: 1 },
  co2: { unit: "t", decimals: 0 },
  buildings: { unit: "", decimals: 0 },
};
export const REPORT_TYPES = [
  { id: "complete", label: "Rapport complet", hint: "Impacts + coûts" },
  { id: "impact", label: "Rapport d’impact", hint: "Surfaces et impacts" },
  { id: "cost", label: "Rapport des coûts", hint: "Coût des sauvés" },
  { id: "preserve", label: "Rapport de préservation", hint: "Zone préservée" },
  { id: "menace", label: "Rapport de la zone menacée", hint: "Zone menacée" },
  {
    id: "sinistre",
    label: "Rapport de la zone sinistrée",
    hint: "Zone sinistrée",
  },
];
export const DEFAULT_UNIT_VALUES = {
  pin: 3750,
  chene: 3750,
  conifere: 3750,
  feuillus: 3750,
  mixte: 3750,
  shrubland: 500,
  grassland: 500,
  co2: 83,
  building: 4300
};

export const RESOURCE_CATEGORIES = [
  {
    id: "terrestre",
    title: "Moyens terrestres",
    labelPlaceholder: "Nom du moyen",
    qtyPlaceholder: "Qté",
    pricePlaceholder: "€ / unité",
    addLabel: "Ajouter un moyen terrestre",
  },
  {
    id: "aérien",
    title: "Moyens aériens",
    labelPlaceholder: "Nom du moyen",
    qtyPlaceholder: "Qté",
    pricePlaceholder: "€ / unité",
    addLabel: "Ajouter un moyen aérien",
  },
  {
    id: "humain",
    title: "Moyens humains",
    labelPlaceholder: "Personnel",
    labelOptions: ["Officier", "Sous-officier", "Homme du rang"],
    qtyPlaceholder: "Nbre",
    pricePlaceholder: "€ / personne",
    addLabel: "Ajouter du personnel",
  },
];

export const newResource = (category) => ({
  id: `${category}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  category,
  label: "",
  quantity: "",
  unitCost: "",
});
export const TYPE_LABELS = {
  terrestre: "Moyens terrestres",
  aérien: "Moyens aériens",
  humain: "Moyens humains",
};
export const TYPE_ORDER = ["terrestre", "aérien", "humain"];
export const FOCUS = [
  { id: "menace", label: "Menacé", key: "menace" },
  { id: "saved", label: "Préservé", key: "preserve" },
  { id: "burned", label: "Sinistré", key: "sinistre" },
];
export const SEVERITY_INDICES = [
  { value: "F", label: "Faible", hours: 2 },
  { value: "L", label: "Léger", hours: 3 },
  { value: "M", label: "Modéré", hours: 4 },
  { value: "S", label: "Sévère", hours: 6 },
  { value: "TS", label: "Très sévère", hours: 8 },
  { value: "E", label: "Exceptionnel", hours: 10 },
];